import { render, staticRenderFns } from "./DocumentSidebar.vue?vue&type=template&id=88b85ec8&scoped=true"
import script from "./DocumentSidebar.vue?vue&type=script&lang=js"
export * from "./DocumentSidebar.vue?vue&type=script&lang=js"
import style0 from "./DocumentSidebar.vue?vue&type=style&index=0&id=88b85ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b85ec8",
  null
  
)

export default component.exports